module.exports = __webpack_public_path__ + "img/bs-7.5a516988.jpg";